import {Routes} from 'constants/routes';

import React from 'react';

import Icon from 'components/Icon/Icon';
import moment from 'moment';
import {useNavigate} from 'react-router';
import PubPage from 'typescript/models/PubPage';

interface IProps {
  pub: PubPage;
}

export const PubPageTableItem = ({pub}: IProps) => {
  const navigate = useNavigate();

  const handleSinglePub = () => navigate(`${Routes.PUB_PAGES_VIEW}/${pub.id}`);

  return (
    <div className="pub-pages__body-item-wrapper" role="button" aria-label="Open single pub" onClick={handleSinglePub}>
      <div className="pub-pages__body-item pub-pages__body-item--name">
        {pub.attributes.pub_logo ? (
          <img src={pub.attributes.pub_logo} alt="single pub logo" />
        ) : (
          <span>
            <Icon icon="image-placeholder" />
          </span>
        )}
        {pub.attributes.name || '/'}
      </div>
      <div className="pub-pages__body-item pub-pages__body-item--activity">
        {pub.attributes.updated_at ? moment(pub.attributes.updated_at).format('DD MMMM YYYY') : '-/-/-'}
      </div>
      <div className="pub-pages__body-item pub-pages__body-item--count">{pub.attributes.posts_count}</div>
      <div className="pub-pages__body-item pub-pages__body-item--city">{pub.attributes.city}</div>
      <div className="pub-pages__body-item pub-pages__body-item--empty">
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${Routes.PUB_PAGES_EDIT}/${pub.id}`);
          }}
        >
          <Icon icon="edit" />
        </button>
      </div>
    </div>
  );
};
